module.exports = __webpack_public_path__ + "img/logo_pruebate.f1703478.svg";